export default __webpack_public_path__ + "782d714c74747c3648d7525c6c272d20.woff2";